(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbDocumentNotes', ['$timeout', DocumentNotesDirective])
		.controller('smbDocumentNotesController', ['smbDocumentNotesDataStore', 'pxAuthService', DocumentNotesController]);

	var templateUrl = require('./documentNotes.template');
	function DocumentNotesDirective($timeout) {
		return {
			restrict: 'E',
			controller: 'smbDocumentNotesController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				documentId: '@'
			},
			scope: {},
			link: function(scope, element, attrs){
				scope.$watchCollection('vm.notesDS.notes', function (newVal) {
					if (!newVal) { return;}
					scroll();
				});
				function scroll() {
					$timeout(function () {
						var scrollElment = element[0].querySelector('.smb-app-doc-comments__comment-list');
						if (scrollElment) {
							scrollElment.scrollTop = scrollElment.scrollHeight;
							scope.vm.loaded = true;
						}
					}, 100);
				}
				
				scroll();
			}
		};
	}

	function DocumentNotesController(smbDocumentNotesDataStore, pxAuthService) {
		var vm = this;
		vm.loaded = false;
		vm.notesDS = smbDocumentNotesDataStore;
		vm.authService = pxAuthService; 
		vm.notesDS.loadNotes(vm.documentId);
		vm.newCommentText = '';
		vm.postComment = postComment;

		function postComment() {
			if (vm.newCommentText) {
				var note = { text: vm.newCommentText };
				vm.notesDS.createNote(vm.documentId, note)
					.then(function() {
						vm.newCommentText = '';
					});
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentNotes/documentNotes.js
// module id = 85
// module chunks = 1